<!-- @format -->

@if (isAttainmentTreeGroupNode(attainmentNode)) {
  <sis-expandable
    [title]="attainmentNode.name | localizedString"
    [variant]="'naked-dotted'"
    [contentPadding]="'none'"
    [level]="expandableLevel"
    [closed]="isClosed$ | async"
    (closedChange)="setClosed($event)">
    <ng-template sisExpandableContent>
      @for (childNode of attainmentNode.childNodes; track childNode) {
        <app-student-attainment-node-wrapper [attainmentNode]="childNode" [expandableLevel]="expandableLevel + 1" />
      }
    </ng-template>
  </sis-expandable>
}

@if (isAttainmentTreeAttainmentNode(attainmentNode)) {
  <sis-attainment-structure-node
    [attainment]="attainmentNode.attainment"
    [code]="attainmentNode.code"
    [name]="attainmentNode.name"
    [grade]="attainmentNode.grade"
    [hasValidParentAttainment]="attainmentNode.hasValidParentAttainment"
    [expandableLevel]="expandableLevel"
    [closed]="isClosed$ | async"
    (openDetailsModal)="openAttainmentDetailsModal(attainmentNode.attainment)"
    (closedChange)="setClosed($event)">
    @for (childNode of attainmentNode.childNodes; track childNode) {
      <app-student-attainment-node-wrapper [attainmentNode]="childNode" [expandableLevel]="expandableLevel + 1" />
    }
  </sis-attainment-structure-node>
}
